import styled from 'styled-components';
import noop from 'utils/noop';
import { zIndex } from 'ui/theme';
import { CHECKBOX_STATUS } from 'ui/checkbox';
import { GroupSelectTrigger } from './GroupSelectTrigger';
import { SELECTIONS } from './constants';

const GroupSelectWrapper = styled.div`
  align-items: center;
  display: flex;
  z-index: ${zIndex.dropdown};
`;

// export type GroupSelectProps = {
//   /** handle select all */
//   onSelectAll: () => void,
//   /** handle select none */
//   onSelectNone: () => void,
//   /** State to force on checkbox */
//   status?: string,
//   /** wheher or not to disable the menu and checkbox */
//   isDisabled?: boolean,
// };

export const GroupSelect = ({
  onSelectAll = noop,
  onSelectNone = noop,
  status = CHECKBOX_STATUS.UNCHECKED,
  isDisabled = false,
}) => {
  const handleSelect = (selected) => {
    // selected is returned in an array
    if (selected[0] === SELECTIONS.ALL) {
      onSelectAll();
    } else if (selected[0] === SELECTIONS.NONE) {
      onSelectNone();
    }
  };

  const handleCheckboxClick = () => {
    if (status !== CHECKBOX_STATUS.CHECKED) {
      // because selected is returned in an array we pass in forced selections in an array
      handleSelect([SELECTIONS.ALL]);
    } else {
      handleSelect([SELECTIONS.NONE]);
    }
  };

  return (
    <GroupSelectWrapper data-test="group-select">
      <GroupSelectTrigger
        status={status}
        onCheckboxClick={handleCheckboxClick}
        isDisabled={isDisabled}
      />
    </GroupSelectWrapper>
  );
};
